import Dexie, {type Table} from "dexie";

export interface GeographyMasterCache {
    get(key: string): Promise<unknown>;
    put(key: string, data: unknown): Promise<void>;
    remove(key: string): Promise<void>;
    removeByPrefixExcept(prefix: string, keepKey: string): Promise<void>;
}

/** Public geography masters are shared across users; API origin and revision are part of each key. */
export class GeographyDatabase extends Dexie implements GeographyMasterCache {
    private datasets!: Table<{key: string; data: unknown}, string>;

    constructor(name = "VestaGeographyMasters") {
        super(name);
        this.version(1).stores({datasets: "key"});
    }

    async get(key: string): Promise<unknown> {
        return (await this.datasets.get(key))?.data;
    }

    async put(key: string, data: unknown): Promise<void> {
        await this.datasets.put({key, data});
    }

    async remove(key: string): Promise<void> {
        await this.datasets.delete(key);
    }

    async removeByPrefixExcept(prefix: string, keepKey: string): Promise<void> {
        await this.datasets
            .where("key")
            .startsWith(prefix)
            .and((row) => row.key !== keepKey)
            .delete();
    }
}

let database: GeographyDatabase | undefined;

export function getGeographyMasterCache(): GeographyMasterCache {
    database ??= new GeographyDatabase();
    return database;
}
